import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertaService } from 'src/app/util/alerta.service';
import { IntranetService } from '../../intranet.service';
import { Organizador } from '../../model/asamblea';
import { saveAs } from 'file-saver';
import { functionUtil } from 'src/app/util/functionConst';

@Component({
    selector: 'sura-importacion-fondo',
    templateUrl: './importacion-fondo.component.html',
    styleUrls: ['./importacion-fondo.component.scss'],
    providers: [DatePipe]
})
export class ImportacionFondoComponent implements OnInit {
    linkActive = '';
    listaOrganizadores: Organizador[] = [];
    participesFondoForm: UntypedFormGroup;
    uploadParticipesFondoForm: UntypedFormGroup;
    showUploadForm = false;

    fnKeyDownNumeric = functionUtil.fnKeyDownNumeric;
    fnInputMaxLength = functionUtil.fnInputMaxLength;
    fnNumericMobile = functionUtil.fnNumericMobile;

    constructor(
        private router: Router,
        private intranetService: IntranetService,
        private alertaService: AlertaService,
        private fb: UntypedFormBuilder,
        private datePipe: DatePipe) {
        this.linkActive = this.router.url;

        this.participesFondoForm = this.fb.group({
            codigoAlterno: ['', Validators.required],
            fechaRegistro: ['', Validators.required],
        });

        this.uploadParticipesFondoForm = this.fb.group({
            numeroAsamblea: this.fb.control('', [Validators.required, Validators.maxLength(6)])
        });
    }

    ngOnInit() {
        this.intranetService.listarOrganizadores().then(resultado => {
            if (resultado instanceof Array) {
              this.listaOrganizadores = resultado;
            }
          }).catch(error => {
            this.alertaService.error(error);
          });
    }

    onDownloadParticipesFondo() {
        if (this.participesFondoForm.valid) {
            const codigoAlterno = this.participesFondoForm.controls.codigoAlterno.value;
            const fecha = this.datePipe.transform(this.participesFondoForm.controls.fechaRegistro.value, 'yyyy-MM-dd');

            console.log(`codigoAlterno=${codigoAlterno}, fecha=${fecha}`);

            this.intranetService.downloadParticipesFondo(codigoAlterno, fecha)
            .subscribe(
                data => {
                    saveAs(data, 'Reporte-Participes-Fondo.xlsx');
                    this.showUploadForm = true;
                },
                err => {
                    this.alertaService.error('Problem while downloading the file.');
                    console.error(err);
                }
              );
        }
    }

    onUploadParticipesFondo() {
        if (this.uploadParticipesFondoForm.valid && this.participesFondoForm.valid) {
          this.intranetService.uploadParticipesFondo({
              numeroAsamblea: this.uploadParticipesFondoForm.controls.numeroAsamblea.value,
              fecha: this.datePipe.transform(this.participesFondoForm.controls.fechaRegistro.value, 'yyyy-MM-dd'),
              codigoAlterno: this.participesFondoForm.controls.codigoAlterno.value,
          }).then(resp => {
              if (resp['status'] === '200') {
                  this.alertaService.success('Se importó correctamente la data.');
              } else if (resp['mensaje']) {
                  this.alertaService.error(resp['mensaje']);
              } else {
                  this.alertaService.error('Error en la imporación de la data, intente de nuevo.');
              }
          }).catch(err => {
            this.alertaService.error(err);
          });
        } else {
            this.alertaService.warning('Ingrese todos los campos!');
        }
    }
}
